import { tableColumnsType } from '../components/edit-table/editable-table';
import linkExceptions from '../services/Utils/linkExceptions';
const consumableLifeCycleColumns = (): tableColumnsType[] => {
  return [
    // {
    //   Header: 'Sl. No.',
    //   accessor: 'displayseq',
    //   editType: 'inputField',
    //   options: []
    // },
    {
      Header: 'Area',
      accessor: 'areacode',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Zone',
      accessor: 'zonecode',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Equipment',
      accessor: 'equipmentcode',
      editType: 'inputField',
      options: [],
      linkType: true,
    },
    {
      Header: 'Consumable Description',
      accessor: 'consumabledescription',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Consumable Code',
      accessor: 'consumablecode',
      editType: 'inputField',
      options: [],
      linkType: true,
      linkExceptions: linkExceptions,
    },
    {
      Header: 'Company Consumable Description',
      accessor: 'companyConsumableDesc',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Company Consumable Code',
      accessor: 'companyConsumableCode',
      editType: 'inputField',
      options: [],
      linkType: true,
      linkExceptions: linkExceptions,
    },
    {
      Header: 'Lifetime (t)',
      accessor: 'lifetime',
      editType: 'Number',
      options: [],
    },
    {
      Header: 'Cycles',
      accessor: 'cycles',
      editType: 'Number',
      options: [],
    },
    {
      Header: 'Max. Cycles',
      accessor: 'maxCycles',
      editType: 'Number',
      options: [],
    },
  ];
};

export default consumableLifeCycleColumns;
